// Association.State — structural tuples between independent entities.
//
// Flexible-entity migration steps 3 + 4 (.claude/analysis/flexible-entity-
// model.md §3.2). The same Zanzibar tuple shape as the KnowledgeBank,
// opposite side of the Structure-vs-Content line: KB tuples are CONTENT
// (measured, agent-writable), these are STRUCTURE (gate-bearing, never
// agent-writable). Two edge kinds:
//
//   - Membership: a Scope references a Resource (share, no copy). This
//     GENERALIZES Project's `resource_added_to_project` — Project stops
//     owning a bespoke membership mechanism; membership moves to this
//     shared substrate keyed by ScopeId.
//   - Grant: a User holds a Role at a Scope. The role lives on the
//     grant, never on the user.
//
// Edges are content-addressed (Zanzibar `object#relation@subject` is a
// tuple, not a surrogate id) — so there is NO AssociationId brand; the
// tuple itself is the key. Stored as Maps keyed by a deterministic
// tuple-key string, giving O(1) membership tests and structural
// (not object-identity) equality — the same problem Project.decide
// solved by hand for resource refs, solved once here.
export { grantKey, initial, membershipKey, mkGrant, mkMembership };
import * as Role from "./role.js";
const mkMembership = (scopeId, resource) => ({ scopeId, resource });
// A claim ref has no version (knowledge-bank.md §11.1).
const membershipKey = (m) => `${m.scopeId}|${m.resource.type}:${m.resource.id}:${"version" in m.resource ? m.resource.version : ""}`;
const mkGrant = (userId, scopeId, roleId) => ({ userId, scopeId, roleId });
const grantKey = (g) => `${g.userId}|${g.scopeId}|${g.roleId}`;
const initial = {
    memberships: new Map(),
    grants: new Map(),
    roles: new Map(Role.PRESET_ROLES),
};
//# sourceMappingURL=state.js.map